import {
  HomeOutlined,
  HelpOutline,
  BarChartOutlined,
  SettingsOutlined,
  CloudUploadOutlined,
  ListOutlined,
  AssignmentLateOutlined,
  LoyaltyOutlined,
  PeopleOutline,
  SubscriptionsOutlined,
} from '@maas-components/icons'
import { ERoute } from 'common/entities/routes'
import {
  ROLE_COMPLAINT_LIST,
  ROLE_PRODUCT_LIST,
  ROLE_BRAND_MANAGEMENT,
  ROLE_CRUD_USER,
  ROLE_REASON_COMPLAINT_MANAGEMENT,
  ROLE_ADS_ALLOWED_REPORT,
  ROLE_ADS_REMOVED_REPORT,
  ROLE_ADS_TO_REMOVE_REPORT,
  ROLE_ACTIVE_BRAND_REPORT,
  ROLE_TICKET_GROUPS_REPORT,
  ROLE_TICKETS_REPORT,
  ROLE_REGULATORY_AGENCY_MANAGEMENT,
  ROLE_SUB_SPECIFICATION_MANAGEMENT,
  ROLE_TICKETS_MANAGEMENT,
} from '../../common/constants/roles'

export default [
  {
    name: 'sidebar.links.home',
    icon: HomeOutlined,
    url: ERoute.HOME,
  },
  {
    name: 'sidebar.links.catalog',
    icon: SubscriptionsOutlined,
    url: ERoute.CATALOG,
    roles: [ROLE_PRODUCT_LIST],
  },
  {
    name: 'sidebar.links.users',
    icon: PeopleOutline,
    url: ERoute.USERS,
    roles: [ROLE_CRUD_USER],
  },
  {
    name: 'sidebar.links.brand',
    icon: LoyaltyOutlined,
    url: ERoute.BRAND_MANAGEMENT,
    roles: [ROLE_BRAND_MANAGEMENT],
  },
  {
    name: 'sidebar.links.complaint',
    icon: AssignmentLateOutlined,
    url: ERoute.COMPLAINTS_MANAGEMENT,
    roles: [ROLE_COMPLAINT_LIST],
  },
  {
    name: 'sidebar.links.allComplaintsManagement',
    icon: ListOutlined,
    url: ERoute.ALL_TICKETS_MANAGEMENT,
    roles: [ROLE_TICKETS_MANAGEMENT],
  },
  {
    name: 'sidebar.links.importTickets',
    icon: CloudUploadOutlined,
    url: ERoute.IMPORT_TICKETS,
    roles: [ROLE_TICKETS_MANAGEMENT],
  },
  {
    name: 'sidebar.links.parameters',
    icon: SettingsOutlined,
    url: '',
    roles: [
      ROLE_REGULATORY_AGENCY_MANAGEMENT,
      ROLE_REASON_COMPLAINT_MANAGEMENT,
      ROLE_SUB_SPECIFICATION_MANAGEMENT,
    ],
    links: [
      {
        name: 'sidebar.links.reasonsComplaint',
        url: ERoute.REASON_COMPLAINT_MANAGEMENT,
        roles: [ROLE_REASON_COMPLAINT_MANAGEMENT],
      },
      {
        name: 'sidebar.links.regulatoryAgency',
        url: ERoute.REGULATORY_AGENCY_MANAGEMENT,
        roles: [ROLE_REGULATORY_AGENCY_MANAGEMENT],
      },
      {
        name: 'sidebar.links.subSpecification',
        url: ERoute.SUB_SPECIFICATION_MANAGEMENT,
        roles: [ROLE_SUB_SPECIFICATION_MANAGEMENT],
      },
    ],
  },
  {
    name: 'sidebar.links.reports',
    icon: BarChartOutlined,
    url: ERoute.REPORTS,
    roles: [
      ROLE_ADS_ALLOWED_REPORT,
      ROLE_ADS_REMOVED_REPORT,
      ROLE_ADS_TO_REMOVE_REPORT,
      ROLE_ACTIVE_BRAND_REPORT,
      ROLE_TICKET_GROUPS_REPORT,
      ROLE_TICKETS_REPORT,
    ],
  },
  {
    name: 'sidebar.links.faq',
    icon: HelpOutline,
    url: ERoute.FAQ,
  },
]
